import React, { useMemo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { URLS, Url } from '@wix/da-url';
import EllipsisIcon from '../../../Icons/Ellipsis';
import IconButtonWithContextMenu from '../../../Dropdown/Preset/IconButtonWithContextMenu';
import { SessionContext } from '../../../Context/SessionContext';
var MoreMenu = function (_a) {
    var className = _a.className, iconClassName = _a.iconClassName;
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var t = useTranslation().t;
    var items = useMemo(function () { return [
        {
            key: 'groups',
            label: t('siteHeader.groups'),
            link: URLS.GROUPS,
        },
        {
            key: 'shop',
            label: t('siteHeader.shop'),
            link: URLS.SHOP,
        },
        {
            key: 'forum',
            label: t('siteHeader.forum'),
            link: URLS.FORUM,
        },
        isLoggedIn && {
            key: 'watch',
            label: t('siteHeader.more.oldWatch'),
            link: Url.watchLink(),
        },
    ]; }, [t, isLoggedIn]);
    return (React.createElement(IconButtonWithContextMenu, { items: items, className: className },
        React.createElement(EllipsisIcon, { className: iconClassName, disableDefaultColors: true })));
};
MoreMenu.displayName = 'MoreMenu';
export default MoreMenu;
//# sourceMappingURL=MoreMenu.js.map